module.exports = __webpack_public_path__ + "img/img6.9d8b8989.jpg";